export default "__VITE_ASSET__DFwqRFBg__"